import React from 'react';
import { CheckIcon } from 'lucide-react';
type GoldSealProps = {
  size?: number;
  lines?: [string, string];
  caption?: string;
  className?: string;
};
export function GoldSeal({
  size = 132,
  lines = ['Material', 'Profesional'],
  caption = 'Listo para usar',
  className = ''
}: GoldSealProps) {
  return <div className={`relative shrink-0 drop-shadow-[0_10px_18px_rgba(138,106,36,0.35)] ${className}`} style={{
    width: size,
    height: size
  }} role="img" aria-label={`${lines.join(' ')} — ${caption}`} data-id="element-35" data-mp="nftrwzm37md3">
      <svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-36" data-mp="egoqnlj55ex8">
        <polygon points={scallopPoints(28, 100, 92, 84)} fill="#C9A04A" data-id="element-37" data-mp="3vp3l9365s8ws" />
        <circle cx="100" cy="100" r="78" fill="#D8B35E" data-id="element-38" data-mp="4h7ld57sx31s" />
        <circle cx="100" cy="100" r="70" fill="none" stroke="#8A6A24" strokeWidth="1.5" strokeDasharray="3 4" data-id="element-39" data-mp="4jtu386fholl" />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-petrol-900" data-id="element-40" data-mp="1yvs0z3h9m8eb">
        <CheckIcon className="mb-0.5" style={{
        width: size * 0.16,
        height: size * 0.16
      }} strokeWidth={3} data-id="element-41" data-mp="190pivuzk88eh" />
        <span className="font-serif leading-[0.95]" style={{
        fontSize: size * 0.115
      }} data-id="element-42" data-mp="14138dtb4969d">
          {lines[0]}
          <br data-id="element-43" data-mp="1ipzcjfa1xz4p" />
          {lines[1]}
        </span>
        <span className="mt-1 font-semibold uppercase tracking-[0.08em]" style={{
        fontSize: size * 0.06
      }} data-id="element-44" data-mp="1dr61dti8mk7p">
          {caption}
        </span>
      </div>
    </div>;
}
function scallopPoints(count: number, center: number, outer: number, inner: number) {
  const pts: string[] = [];
  for (let i = 0; i < count * 2; i++) {
    const r = i % 2 === 0 ? outer : inner;
    const a = Math.PI * i / count;
    pts.push(`${(center + r * Math.cos(a)).toFixed(1)},${(center + r * Math.sin(a)).toFixed(1)}`);
  }
  return pts.join(' ');
}